import baseTheme from '../baseTheme';
import { glow } from '../effects';
var CIRCLE_SIZE = 18;
var INDICATOR_SIZE = 5;
var MuiRadio = {
    /* your custom class style overrides here */
    root: {
        border: "2px solid " + baseTheme.palette.secondary.main,
        padding: '2px',
        width: CIRCLE_SIZE,
        height: CIRCLE_SIZE,
        margin: '8px',
        position: 'relative',
        flex: '0 0 auto',
        '&::before': {
            content: '""',
            position: 'absolute',
            backgroundColor: baseTheme.palette.secondary.contrastText,
            borderRadius: '100%',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: 0,
            height: 0,
            opacity: 0,
            transition: baseTheme.transitions.create(['width', 'height', 'opacity']),
        },
        '&:hover': {
            background: baseTheme.palette.primary.light,
        },
        '&.Mui-disabled': {
            background: baseTheme.palette.grey[200],
            borderColor: baseTheme.palette.grey[400],
        },
        '&.Mui-checked': glow({
            backgroundColor: baseTheme.palette.secondary.main,
            color: baseTheme.palette.secondary.contrastText,
            '&::before': {
                width: INDICATOR_SIZE,
                height: INDICATOR_SIZE,
                opacity: 1,
            },
            '&:hover': {
                backgroundColor: baseTheme.palette.secondary.main,
            },
            '&.Mui-disabled': {
                background: baseTheme.palette.grey[400],
                borderColor: baseTheme.palette.grey[400],
                color: baseTheme.palette.grey[50],
            },
        }),
    },
    colorSecondary: {
        color: baseTheme.palette.secondary.main,
        '&.Mui-checked': {
            color: baseTheme.palette.secondary.contrastText,
            '&:hover': {
                backgroundColor: baseTheme.palette.secondary.main,
                borderColor: baseTheme.palette.secondary.main,
            },
            '&.Mui-disabled': {
                background: baseTheme.palette.grey[400],
                borderColor: baseTheme.palette.grey[400],
                color: baseTheme.palette.grey[50],
            },
        },
    },
};
export default MuiRadio;
//# sourceMappingURL=MuiRadio.js.map